// components/Profile.js
import "./Profile.css";
import camera from "../assets/camera.png";
import Connected_header from "../components/connected_header.js";
import React, { useContext } from "react";
import { AuthContext } from "../services/AuthProvider.js";
import useApiService from "../hooks/useApiService.js";

function Profile() {
  const { authData, clearAuthData } = useContext(AuthContext);
  const { data: userData, loading } = useApiService(
    "api/users/me",
    "GET",
    null,
    [authData?.token]
  );

  const logout = () => {
    console.log("Logout");
    clearAuthData();
    window.location.href = "/login";
  };

  return (
    <>
      {loading ? (
        <>
          <Connected_header />
          <h4>Loading...</h4>
        </>
      ) : userData ? (
        <>
          <Connected_header
            name={userData.last_name + ". " + userData.first_name.slice(0, 1)}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
            }}
          >
            <h3 className="mon_compte">Mon Compte</h3>
            <div className="image_div">
              <img
                style={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: "4px solid white",
                  boxShadow: "0px 0px 10px 1px rgba(170,170,170)",
                  borderColor: "white",
                  boxSizing: "border-box",
                }}
                src={userData.picture ? userData.picture : "https://picturehappertest.blob.core.windows.net/8987779586250999-undefined/377617635542957-picture.png"}
                alt="user image"
              />
              <img className="camera_image" src={camera} alt="user image" />
            </div>
            <div className="fields_div">
              {champ("Nom", userData.first_name)}
              {champ("Prénom", userData.last_name)}
              {champ("Adresse", userData.address)}
              {champ("Code postal", userData.postal_code)}
              {champ("Ville", userData.city)}
              {champ("E-mail", userData.email)}
              {champ("Date de naissance", userData.birthdate)}
              {champ("Numéro de téléphone", userData.phone)}
              {champ("Mot de passe", "************")}
              {champ("Supprimer mon compte ", "")}
            </div>

            <div className="footer_div">
              <div className="space"></div>
              {/* <button
                style={{
                  height: "40px",
                  width: "160px",
                  padding: "8px",
                  border: "none",
                  borderRadius: "7px",
                  background: "linear-gradient(90deg, #ff3668, #ff6b16)",
                  color: "white",
                  fontSize: "1em",
                  fontWeight: "bold",
                  cursor: "pointer",
                  transition: "background-color 0.2s",
                }}
              >
                +UPLOAD
              </button> */}
              <button onClick={logout}
                style={{
                  height: "40px",
                  width: "160px",
                  padding: "8px",
                  border: "none",
                  borderRadius: "7px",
                  background: "linear-gradient(90deg, #ff3668, #ff6b16)",
                  color: "white",
                  fontSize: "1em",
                  fontWeight: "bold",
                  cursor: "pointer",
                  transition: "background-color 0.2s",
                }}>Logout</button>
              <div className="space"></div>
              <p className="footer_text">CGU</p>
              <p className="footer_text">CGV</p>
              <p className="footer_text">Politique de confidentialité</p>
              <div className="space"></div>
            </div>
          </div>
        </>
      ) : (
        <>
          <Connected_header />
          <h4>No user data found</h4>
        </>
      )}
    </>
  );
}

function champ(name, value) {
  return (
    <>
      <div style={{ display: "flex", width: "80%", textAlign: "start" }}>
        <h2 className="field_text">{name}</h2>
        <p className="value_text">{value}</p>
        <div style={{ flexGrow: "1" }}></div>
      </div>
      <div className="devider"></div>
    </>
  );
}

export default Profile;
